import React from "react";
import { mergeStyles } from "@fluentui/react/lib/Styling";
import { FontIcon, Stack } from "@fluentui/react";

export interface ActiveConfigurationProps {
  tooltip?: string;
  authenticated?: boolean;
}

function ActiveConfiguration({ tooltip, authenticated }: ActiveConfigurationProps) {
  const iconClass = mergeStyles({
    color: authenticated ? "rgb(133, 188, 32)" : "rgb(162, 166, 175)",
    marginRight: "5px",
  });

  const toolTipClass = mergeStyles({
    color: "rgb(189, 189, 189)",
  });

  const iconName = authenticated ? "CompletedSolid" : "Blocked2Solid";

  return (
    <Stack horizontal>
      <FontIcon iconName={iconName} className={iconClass}></FontIcon>
      <div className={toolTipClass}>{tooltip}</div>
    </Stack>
  );
}

export default ActiveConfiguration;
